export default __webpack_public_path__ + "static/media/nextNew.e06b3bbb.svg";